import { useMemo, useContext } from 'react';
import ReactEcharts from 'echarts-for-react';
import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import { fmtThousand } from '@/utils/comUtil';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { sinTimeDimensionSinIndexMulValue } from '@/utils/reportResponseUtil';

// 图表容器样式与坐标轴格式化函数提到模块级，保证引用稳定，
// 避免 ReactEcharts 因为 props 引用变化而重复 setOption
const CHART_STYLE = { width: '100%', height: '100%' };
const alwaysShowInterval = () => {
  return true;
};
const fmtBarLabelThousand = (p) => {
  return `${fmtThousand(p.value)}`;
};

const LevelDistribution = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const { loading, data } = props;

  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const chartOption = useMemo(() => {
    if (data.length === 0) {
      return {};
    }
    let yDataUse = [];
    let seriesData = [];
    sinTimeDimensionSinIndexMulValue(data || []).forEach((e) => {
      yDataUse.push(e.LABEL);
      seriesData.push(e.VALUE);
    });
    let option = {
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        textStyle: {
          fontSize: chartsFontSize.s03,
        },
      },
      // barWidth: 20,
      barCategoryGap: '50%',
      grid: {
        top: 10,
        left: 10,
        right: 10,
        bottom: -20,
        containLabel: true,
      },
      xAxis: {
        show: false,
        type: 'value',
        // boundaryGap: [0, 0.01],
        axisTick: true,
        axisLine: true,
        splitLine: {
          show: false,
        },
      },
      yAxis: {
        // name: formatMessage({ id: 'comm.unit.lbl03' }),
        nameGap: 5,
        nameTextStyle: {
          color: charts.yColor,
          // padding: [0, 20, 0, 0],
        },
        // boundaryGap: [0, 0.3],
        type: 'category',
        data: yDataUse, // ['银卡会员', '银卡会员', '银卡会员', '银卡会员'],
        axisTick: true,
        axisLine: true,
        axisLabel: {
          textStyle: {
            color: charts.yColor, //坐标值得具体的颜色
            fontSize: chartsFontSize.s03,
          },
          interval: alwaysShowInterval,
        },
        splitLine: {
          show: false,
        },
      },
      color: charts.barColorList,
      // series: seriesData,
      series: {
        data: seriesData,
        type: 'bar',
        barWidth: '50%',
        barMinHeight: 80,
        itemStyle: {
          normal: {
            label: {
              show: true,
              position: 'insideRight',
              formatter: fmtBarLabelThousand,
            },
          },
        },
      },
    };

    return option;
  }, [
    charts.barColorList,
    charts.yColor,
    chartsFontSize.s03,
    data,
    fontFamily,
  ]);

  return (
    <>
      <Head boxId={'ec.dashboard.n05.lbl01'}></Head>
      <Body bizData={data} loading={loading}>
        <ReactEcharts
          style={CHART_STYLE}
          option={chartOption}
          notMerge={true}
          lazyUpdate={true}
        />
      </Body>
    </>
  );
};
export default LevelDistribution;
